	import React, { Fragment, useContext, useState } from "react";
/// React router dom
import { Link } from "react-router-dom";
import { ThemeContext } from "../../../context/ThemeContext";

import logo2 from "../../../images/red-no-logo.png";
const NavHader = () => {
  const [toggle, setToggle] = useState(false);
  const width=window.innerWidth
  const { navigationHader, openMenuToggle, background } = useContext(
    ThemeContext
  );
  return (
    <div className="nav-header">
      <Link to="/" className="brand-logo">
        {background.value === "dark" || navigationHader !== "color_1" ? (
          <Fragment>
				<svg className="logo-abbr" width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path className="svg-logo-path" d="M0 12C0 5.37258 5.37258 0 12 0H26C40.3594 0 52 11.6406 52 26C52 40.3594 40.3594 52 26 52C11.6406 52 0 40.3594 0 26V12Z" fill="#43DC80"/>
					<mask id="mask0" maskUnits="userSpaceOnUse" x="0" y="0" width="52" height="52">
					<path  className="svg-logo-path" d="M0 12C0 5.37258 5.37258 0 12 0H26C40.3594 0 52 11.6406 52 26C52 40.3594 40.3594 52 26 52C11.6406 52 0 40.3594 0 26V12Z" fill="#43DC80"/>
					</mask>
					<g mask="url(#mask0)">
					<circle className="svg-logo-circle" cx="54" cy="13" r="26" fill="#34D574"/>
					<circle className="svg-logo-circle" cx="23" cy="62" r="20" fill="#50E98D"/>
					<circle className="svg-logo-circle" cx="12.5" cy="41.5" r="13" stroke="#50E98D"/>
					</g>
					<path  className="svg-logo-text" d="M18.652 37V21.208C18.652 19.9013 18.904 18.8933 19.408 18.184C19.9307 17.456 20.5747 16.952 21.34 16.672C22.1053 16.3733 22.8707 16.224 23.636 16.224C24.252 16.224 25.064 16.2333 26.072 16.252C27.08 16.2707 28.172 16.308 29.348 16.364C30.524 16.42 31.644 16.5133 32.708 16.644V20.704H25.008C24.4853 20.704 24.1027 20.844 23.86 21.124C23.6173 21.404 23.496 21.7307 23.496 22.104V25.016L31.336 25.268V29.104L23.496 29.356V37H18.652Z" fill="white"/>
				</svg>
				
          </Fragment>
        ) : (
          <Fragment>
				<img class="img-fluid" style={{marginLeft:width<500&&200}} alt="Responsive image" src={logo2}/>
          </Fragment>
        )}
      </Link>

      <div
        className="nav-control"
        onClick={() => {
          setToggle(!toggle);
          openMenuToggle();
        }}
      >
        <div className={`hamburger ${toggle ? "is-active" : ""}`}>
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
      </div>
    </div>
  );
};

export default NavHader;
